import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CallingDelegate } from '../../../shared/models/generated/ziroModels';

@Injectable()
export class DelegateManagementResource {
  private $http = inject(HttpClient);

  getCallingDelegate(tenantId: string, upn: string): Observable<CallingDelegate> {
    return this.$http.get<CallingDelegate>(
      `/services/microsoft/teams-user-management/tenants/${tenantId}/teams-calling-delegates/${upn}`,
    );
  }

  putCallingDelegate(tenantId: string, callingDelegate: CallingDelegate): Observable<void> {
    return this.$http.put<void>(
      `/services/microsoft/teams-user-management/tenants/${tenantId}/teams-calling-delegates/${callingDelegate.userPrincipalName}`,
      callingDelegate,
    );
  }
}
